/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetDocumentStatsQueryResponse, IngestionStatusControllerGetDocumentStatsQueryParams, IngestionStatusControllerGetDocumentStats403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetDocumentStats";

function getIngestionStatusControllerGetDocumentStatsUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/ingestion-status/documents` as const }  
  return res
}

/**
 * @description Returns statistics about document creation and processing, including counts by status, processing step breakdown, and time series data. Requires System Administrator role.
 * @summary Get document ingestion statistics
 * {@link /api/v1/documents/ingestion-status/documents}
 */
export async function ingestionStatusControllerGetDocumentStats(params?: IngestionStatusControllerGetDocumentStatsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IngestionStatusControllerGetDocumentStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetDocumentStats403>, unknown>({ method : "GET", url : getIngestionStatusControllerGetDocumentStatsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}